import { provideEffects } from '@ngrx/effects';
import { CategoryAirplaySecurityProfilePresetConfigurationEffects } from './category-airplay-security-profile-preset-configuration.effects';

export const provideCategoryAirplaySecurityProfilePresetConfigurationStore = () => [
  provideEffects([CategoryAirplaySecurityProfilePresetConfigurationEffects]),
];
